import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import * as echarts from 'echarts'
import { colorArray as chartColors } from './config'
import { DeviceMonitorStatsChartData } from '../types'


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: DeviceMonitorStatsChartData[]
}


const chart = ref()

watch(
  () => props.data,
  (newData) => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.setOption({
          series: [
            {
              data: newData || [],
            },
          ],
        })
      }
    }
  },
  { immediate: true, deep: true },
)
onMounted(() => {
  // 添加视图变化监听重新渲染图表
  window.addEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})
const chartOption = computed(() => {
  return {
    color: chartColors,
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      right: 0,
      top: 'center',
      height: 80,
      bottom: 0,
      width: '30%',
      itemGap: 10,
      textStyle: {
        color: '#fff',
      },
    },
    grid: {
      left: 0,
      right: '30%',
      top: '10%',
      bottom: 0,
      containLabel: false,
    },
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: ['0%', '90%'], // 调整为环形并放大
        center: ['25%', '50%'], // 饼图居左，占70%
        data: [
          // { value: 1048, name: 'Search Engine' },
          // { value: 735, name: 'Direct' },
          // { value: 580, name: 'Email' },
          // { value: 484, name: 'Union Ads' },
          // { value: 300, name: 'Video Ads' },
        ],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"100%","height":"100%"},
    ref_key: "chart",
    ref: chart
  }, null, 512))
}
}

})